<template>
  <v-list>
    <div v-for="item in items" :key="item.Id">
      <v-list-group v-if="item.Items" color="warning lighten-5">
        <template v-slot:activator>
          <v-list-item-icon v-if="item.Icon" :class="'mr-2 ml-'+subitem*3">
            <v-icon>{{item.Icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-title :class="item.Icon?'':'ml-'+subitem*3">{{item.Title}}</v-list-item-title>
        </template>
        <menulists :items="item.Items" :subitem="subitem+1" :class="'success darken-'+(subitem+1)"></menulists>
      </v-list-group>
      <v-list-item v-else link router :to="item.Url">
        <v-list-item-icon v-if="item.Icon" :class="'mr-2 ml-'+subitem*3">
          <v-icon>{{item.Icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-title :class="item.Icon?'':'ml-'+subitem*3">{{item.Title}}</v-list-item-title>
      </v-list-item>
    </div>
  </v-list>
</template>
<script>
  export default {
    name: 'menulists',
    props: {
      items: {
        type: Array,
        default: []
      },
      subitem: {
        type: Number,
        default: 0
      }
    }
  }
</script>